import { IVehicleData } from 'types/vehicleTypes'

export const selectVehiclesByIds = (ids: number[], vehicles: IVehicleData[]) => {
  if (!ids) {
    return null
  }

  return vehicles.filter((item) => ids?.indexOf(item.vehicle.InstanceID) >= 0)
}
